import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 40px;
`;

export const FakeBox = styled.div`
  width: 62px;
  height: 56px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const Menu = styled.div``;

export const Link = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  color: #343536;
  font-weight: 500;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const NoLink = styled.p`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  color: #343536;
  font-weight: 500;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const BoxModal = styled.div`
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  gap: 20px;
  justify-content: center;
  align-items: center;

  p {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;

  button {
    width: 48%;
  }
`;
